/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2022-04-14 16:01:33
 * @Description: file content
 */ 
import React, { Component } from 'react';
//import OriginMenu from 'bee-menus';
import { getSysFieldid } from '@platform/api';
import { Menu as OriginMenu } from "@tinper/next-ui";
//require('bee-menus/build/Menu.css');
import { microAppUtil } from '@platform/api';
require('./index.less');

class Menu extends Component {
    render() {
        let { getPopupContainer } = this.props;

        return <OriginMenu 
            {...this.props} 
            className={`${this.props.className || ''} nc-menu`}
            getPopupContainer={typeof getPopupContainer === "function" ? getPopupContainer : null}
        />;
    }
}

class Item extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, ...others } = this.props;
        if (fieldid) {
            fieldid = `${fieldid}_sub-btn`;
        }
        return <OriginMenu.Item fieldid={getSysFieldid(fieldid) || null} {...others} />;
    }
}

Menu.SubMenu = OriginMenu.SubMenu;
Menu.ItemGroup = OriginMenu.ItemGroup;
Menu.Item = Item;
Menu.Divider = OriginMenu.Divider;
export default Menu;
